import React, { PureComponent } from 'react'
import Header from './header'
import Sidebar from './sidebar'
import LoginView from '../view/loginView/loginView'
import { autoLogin, logout, tokenLogout } from '../redux/actions/loginAction'
import { connect } from "react-redux";
import Axios from 'axios'
import qs from 'qs'
import cogoToast from 'cogo-toast';
class Layout extends PureComponent {
    constructor() {
        super()
        this.state = {
            isAuthTokenValid: false,
            isAutoLogin: false
        }
    }
    UNSAFE_componentWillMount() {
        let currentAuthToken = this.props.loginReducer.loginUsers.token
        try {
            let authorize = Axios.post(`${process.env.REACT_APP_MAIN_URL}/tokenValidity`, {}, { headers: { 'content-type': 'application/json', 'Authorization': `${currentAuthToken}` } })
            authorize.then((response) => {
                if (response.status === 200) {
                    this.setState({
                        isAuthTokenValid: true
                    });
                }
            })

            authorize.catch((error) => {
                this.setState({
                    isAuthTokenValid: false
                });
                // localStorage.removeItem('isloggedIn')
                localStorage.removeItem('apiToken')
                localStorage.removeItem('userId')
                localStorage.removeItem('customerNo')
                this.props.tokenLogout();
                if (window.location.pathname != "/") {
                    window.location.href = '/'
                }
            })

        } catch (e) {
            console.log(e)
            this.setState({
                isAuthTokenValid: false
            });
            // localStorage.removeItem('isloggedIn')
            localStorage.removeItem('apiToken')
            localStorage.removeItem('userId')
            localStorage.removeItem('customerNo')
            this.props.tokenLogout();
            // window.location.reload()
        }
        this.getAutoLogin()
    }
    getAutoLogin = () => {
        let queryString = qs.parse(window.location.search)
        let userKey = queryString["userKey"] || queryString["?userKey"] || null;
        let globalAccessToken = queryString["token"] || queryString["?token"] || null;
        if (userKey != null && globalAccessToken != null) {
            this.setState({
                isAutoLogin: true
            })
            this.props.autoLogin(globalAccessToken, userKey).then((response) => {
                let tost = cogoToast.loading('Please wait...')
                tost.then(() => {
                    if (response && response.customerNo) {
                        window.location.href = "/transporter-onboarding"
                    } else {
                        tost.then(() => {
                            cogoToast.error('Invalid username or password')
                        })
                    }
                })
            })
        }
    }
    render() {
        return (
            <React.Fragment>
                {this.props.loginReducer && this.props.loginReducer.loginUsers.token ?
                    <>
                        {!this.state.isAutoLogin ? <div className="wrapper">
                            <Sidebar></Sidebar>
                            <Header></Header>
                            <div className="main-panel">{this.props.children}</div>
                        </div> : ''}

                    </> :
                    <>
                        {!this.state.isAutoLogin ? <LoginView /> : ''}
                    </>
                }
            </React.Fragment>
        )
    }
}
const mapStateToProps = ({ loginReducer }) => {
    return {
        loginReducer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => dispatch(logout()),
        tokenLogout: () => dispatch(tokenLogout()),
        autoLogin: (token, userKey) => dispatch(autoLogin(token, userKey))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);